/*
 * AZP-7394 — the PDP's "Replaces Part Numbers" grid.
 *
 * The numbers are not in the page. The metafield this block used to read,
 * `custom.replaces_part_numbers`, is set on 4 of the store's 1,535 products and
 * what it holds is derived from `custom.product_info_brands`, so most of those 4
 * are appliance model numbers rather than part numbers. They come instead from
 * `numbers-<handle>.json`, published next to the index AZP-7008 already builds:
 *
 *   {"h": handle, "n": ["4591539", "AP6329219", "W11210463", ...]}
 *
 * All three kinds in one list — the number printed on the part, the numbers it
 * replaces, and the competitors' — deduplicated and ordered by the backend.
 *
 * Unpaged and fetched on load rather than on scroll, unlike the Compatible
 * Models table below it: a part carries seventeen numbers on average, and this
 * block sits above the description where a shopper sees it without scrolling.
 *
 * A product with no numbers gets no file at all. That 404 is the empty state the
 * design asks for — "part nào không có thì không hiện" — so the block ships
 * hidden and is only revealed once there are numbers to put in it.
 */
(function () {
  "use strict";

  function fill(root) {
    var base = root.dataset.indexBase;
    var handle = root.dataset.handle;
    var version = root.dataset.indexVersion || "";
    var url = base + "numbers-" + handle + ".json";
    if (version) url += "?v=" + encodeURIComponent(version);

    fetch(url)
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .catch(function () {
        // Both "no such file" and "the network said no" leave the block hidden:
        // an empty frame above the description reads as missing data, and the
        // numbers are also still in the description until they are removed there.
        return null;
      })
      .then(function (data) {
        var numbers = (data && data.n) || [];
        if (!numbers.length) return;

        var list = root.querySelector("[data-replaces-part-numbers-list]");
        if (!list) return;

        var fragment = document.createDocumentFragment();
        numbers.forEach(function (number) {
          if (!number) return;
          var item = document.createElement("li");
          item.className = "replaces-part-numbers-item";
          item.textContent = number;
          fragment.appendChild(item);
        });

        list.appendChild(fragment);
        root.hidden = false;
      });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-replaces-part-numbers]").forEach(function (root) {
      if (!root.dataset.indexBase || !root.dataset.handle) return;

      // The Theme Editor re-injects the block's script every time a setting
      // changes; without this the second run appends a second set of numbers.
      if (root.dataset.ready) return;
      root.dataset.ready = "1";

      fill(root);
    });
  });
})();
